<h1 mat-dialog-title>
    <div fxLayout="row" fxLayoutAlign="center stretch">
        <mat-icon>{{ toolbarIcono }}</mat-icon>
        <div class="dialog-title">{{ toolbarTitulo }}</div>
    </div>
</h1>

<div mat-dialog-content>
    <div [innerHtml]="mensaje"></div>
</div>

<div mat-dialog-actions class="btn-container" fxLayout="row" fxLayoutAlign="center stretch">
    <button *ngIf="tipo === dialogType.INFO" mat-raised-button [color]="aceptarBtn.color" [mat-dialog-close]="data" cdkFocusInitial>
        <mat-icon>check</mat-icon>
        {{aceptarBtn.texto}}
    </button>
    <button *ngIf="tipo === dialogType.CONFIRM" mat-raised-button [color]="aceptarBtn.color" [mat-dialog-close]="data"> <mat-icon>check</mat-icon>
        {{aceptarBtn.texto}}
    </button>
    <button *ngIf="tipo === dialogType.CONFIRM" mat-raised-button [color]="cancelarBtn.color" (click)="onNoClick()" cdkFocusInitial> <mat-icon>cancel</mat-icon>
        {{cancelarBtn.texto}}
    </button>
</div>